<template>

<fragment>

	<app-view-common-insight_play-name :item="item" :field="field" />
	<app-view-common-insight_play-stats :item="item" :field="field" />
	<app-view-common-insight_play-players :item="item" :field="field" v-if="field.players === 'enabled'" />

</fragment>

</template>

<script>

export default {

	props: ['field', 'item', 'filter', 'isCondensed', 'isSticky']

}

</script>

<style scoped>

</style>